<template>
  <div id="page-user-list">
    <vx-card ref="filterCard" title="Φίλτρα" class="user-list-filters mb-8" collapseAction
             @refresh="resetColFilters" isContentCollapsed="true">

      <!-- start::validation observer -->
      <validation-observer v-slot="{invalid}">
        <!-- start::form -->
        <form class="xv-row">
          <div class="vx-row">
            <div class="vx-col md:w-1/3 sm:w-1/2 w-full mb-3">
              <validation-provider rule="required" v-slot="{errors}">
                <label class="text-sm">Ημερομηνία</label>
                <flat-pickr v-model="date" :config="{enable: activeDates }" @input="findCrawlingSetsPerDate" class="w-full" name="date"/>
                <span class="text-danger">{{ errors[0] }}</span>
              </validation-provider>
            </div>
            <div class="vx-col md:w-1/3 sm:w-1/2 w-full mb-3">
              <label class="text-sm">Ώρα</label>
              <v-select :options="hours" label="hours" :clearable="false" :dir="$vs.rtl ? 'rtl' : 'ltr'"
                        v-model="selectedHour" class="mb-4 md:mb-0"/>
            </div>
            <div class="vx-col md:w-1/3 sm:w-1/2 w-full mb-3">
              <label class="text-sm">Πηγή
                <vs-button @click="selectedEshop = [...eshops]" type="flat">Επιλογή όλων
                </vs-button>
              </label>
              <v-select :options="eshops" label="name" :clearable="false" :dir="$vs.rtl ? 'rtl' : 'ltr'" :multiple="true"
                        v-model="selectedEshop" class="mb-4 md:mb-0"/>
            </div>
            <div class="vx-col md:w-1/3 sm:w-1/2 w-full mb-3">
              <label class="text-sm customLabel">Κατηγορία
                <vs-button @click="selectedCategory = []" type="flat">Εκκαθάριση
                </vs-button>
              </label>
              <v-select :options="categories" label="name" :clearable="false" :dir="$vs.rtl ? 'rtl' : 'ltr'"
                        @input="getProductsByCategoryId()" v-model="selectedCategory" class="mb-4 md:mb-0"/>
            </div>
            <div class="vx-col md:w-1/3 sm:w-1/2 w-full mb-3">
              <label class="text-sm customLabel">Προϊόν
                <vs-button @click="selectedProduct = []" type="flat">Εκκαθάριση
                </vs-button>
              </label>
              <v-select :options="products" label="name" :clearable="false" :dir="$vs.rtl ? 'rtl' : 'ltr'"
                        v-model="selectedProduct" class="mb-4 md:mb-0"/>
            </div>
            <div class="vx-col md:w-1/3 sm:w-1/2 w-full mb-3">
              <label class="text-sm">Τιμές</label>
              <v-select :options="filterOption" :clearable="false" :dir="$vs.rtl ? 'rtl' : 'ltr'"
                        v-model="selectedFilter"/>
            </div>
            <div class="vx-col md:w-1/6 sm:w-1/2 w-full mb-2">
              <label class="text-sm">Αγαπημένα προϊόντα</label>
              <vs-switch v-model="favouriteFilter" />
            </div>
<!--            <div class="vx-col md:w-1/6 sm:w-1/2 w-full mb-2">-->
<!--              <label class="text-sm">Προιόντα που άλλαξαν</label>-->
<!--              <vs-switch v-model="lastChangedFilter" />-->
<!--            </div>-->
            <div class="vx-col md:w-1/6 sm:w-1/2 w-full mb-2">
              <label class="text-sm">Επιλεγμένο Κατάστημα Skroutz</label>
              <vs-switch v-model="SkroutzSelectedStore" />
            </div>
            <div class="vx-col md:w-1/6 sm:w-1/2 w-full mb-2">
              <label class="text-sm">Διαθέσιμο Μόνο Μέσω FBS</label>
              <vs-switch v-model="OnlyAvailableThroughFBS" />
            </div>
            <div class="vx-col md:w-1/6 sm:w-1/2 w-full mb-2">
              <label class="text-sm">Χορηγούμενο</label>
              <vs-switch v-model="Sponsored" />
            </div>
            <div class="vx-col md:w-1/6 sm:w-1/2 w-full mb-2">
              <label class="text-sm">Δωρεάν Δόσεις</label>
              <vs-switch v-model="MerchantFundedInstallments" />
            </div>
            <div class="vx-col md:w-1/6 sm:w-1/2 w-full mb-2">
              <label class="text-sm">Αντικαταβολή</label>
              <vs-switch v-model="CashOnDelivery" />
            </div>
            <div class="vx-col md:w-1/6 sm:w-1/2 w-full mb-2">
              <label class="text-sm">Δωρεάν Αποστολή</label>
              <vs-switch v-model="FreeShipping" />
            </div>
            <div class="vx-col md:w-1/6 sm:w-1/2 w-full mb-2">
              <label class="text-sm">Επίσημος Μεταπωλητής</label>
              <vs-switch v-model="OfficialReseller" />
            </div>
            <div class="vx-col md:w-1/6 sm:w-1/2 w-full mb-2">
              <label class="text-sm">Marketplace</label>
              <vs-switch v-model="Marketplace" />
            </div>
            <div class="vx-col md:w-1/6 sm:w-1/2 w-full mb-2">
              <label class="text-sm">Σε Απόθεμα</label>
              <vs-switch v-model="Instock" />
            </div>
            <div class="vx-col md:w-1/6 sm:w-1/2 w-full mb-2">
              <label class="text-sm">Pro Seller</label>
              <vs-switch v-model="pro" />
            </div>
            <div class="vx-col md:w-1/6 sm:w-1/2 w-full mb-2">
              <label class="text-sm">Υποστιρίζει Greca Trustmark</label>
              <vs-switch v-model="supportsGrecaTrustmark" />
            </div>
            <div class="vx-col md:w-1/6 sm:w-1/2 w-full mb-2">
              <label class="text-sm">Express Delivery</label>
              <vs-switch v-model="castExpressDel" />
            </div>
            <div class="vx-col md:w-1/6 sm:w-1/2 w-full mb-2">
              <label class="text-sm">Προιόντα που άλλαξαν</label>
              <vs-switch v-model="lastChangedFilter" />
            </div>
          </div>
          <div class="vx-row">
            <vs-divider/>
          </div>
          <div class="vx-row">
            <div class="vx-col w-1/2 mb-2 text-left">
              <vs-button @click="filterTable()" color="success" type="border" class="ml-auto mt-6" style="">
                Προιόντα που άλλαξαν
              </vs-button>
            </div>
            <div class="vx-col w-1/2 mb-2 text-right ml-auto" >
              <vs-button :disabled="invalid" @click="generateReports(true)" color="primary" type="border"
                         class="ml-auto mt-6" style="">
                Download Xls
              </vs-button>
              <vs-button :disabled="invalid" @click="generateReports(false)" color="primary" type="filled"
                         class="ml-6 mt-6">
                Δημιουργία Report
              </vs-button>
            </div>
          </div>
        </form>
        <!-- end::form -->
      </validation-observer>
      <!-- end::validation observer -->

    </vx-card>

    <div class="vx-card p-6">
      <!-- AgGrid Table -->
      <ag-grid-vue ref="agGridTable"
                   :components="components"
                   :gridOptions="gridOptions"
                   class="ag-theme-material w-100 my-4 ag-grid-table"
                   :columnDefs="columnDefs"
                   :defaultColDef="defaultColDef"
                   :rowData="recordsData"
                   rowSelection="multiple"
                   :animateRows="true"
                   :floatingFilter="true"
                   :pagination="false"
                   :groupDisplayType="groupDisplayType"
                   :groupRowRendererParams="groupRowRendererParams"
                   :localeText="localeText"
                   :paginationPageSize="paginationPageSize"
                   :suppressPaginationPanel="true"
                   :sideBar="sideBar"
                   :rowGroupPanelShow="rowGroupPanelShow"
                   @grid-ready="onGridReady"
                   @sort-changed="onColumnMoved"
                   @column-visible="onColumnMoved"
                   @column-pivot-changed="onColumnMoved"
                   @column-row-group-changed="onColumnMoved"
                   @column-value-changed="onColumnMoved"
                   @column-pinned="onColumnMoved"
                   @column-moved="onColumnMoved"
                   :excelStyles="excelStyles"
                   :enableRtl="$vs.rtl">
<!--        @column-moved="onColumnMoved"-->
<!--        @displayed-columns-changed="onColumnChangeStatus"-->
      </ag-grid-vue>

      <div class="flex flex-wrap items-center">
        <hr>
          <p><strong>MAV</strong>: Κερδοφορία βάση τιμής &nbsp;</p>
          <p><strong>MAV1</strong>: Κερδοφορία βάση έκπτωσης &nbsp;</p>
          <p><strong>MAV2</strong>: Κερδοφορία Βάση Τιμής Πηγής &nbsp;</p>
      </div>
    </div>
  </div>
</template>

<script>
import {AgGridVue} from 'ag-grid-vue'
import '@/assets/scss/vuexy/extraComponents/agGridStyleOverride.scss'
import vSelect from 'vue-select'
import flatPickr from 'vue-flatpickr-component'
import 'flatpickr/dist/flatpickr.css'
import 'ag-grid-enterprise'
import AG_GRID_LOCALE_EL from '../../i18n/genericGrid'

// Cell Renderer
import CellRendererLink from './cell-renderer/CellRendererLink.vue'
import CellRendererStatus from './cell-renderer/CellRendererStatus.vue'
import CellRendererChecked from './cell-renderer/CellRendererChecked.vue'
import CellRendererVerified from './cell-renderer/CellRendererVerified.vue'
import CellRendererActions from './cell-renderer/CellRendererActions.vue'
import GroupRowInnerRenderer from './cell-renderer/groupRowInnerRendererVue.js';

import axios from '@/axios'

// Validation
import {extend, ValidationObserver, ValidationProvider} from 'vee-validate'
import {required} from 'vee-validate/dist/rules'

extend('required', {
  ...required,
  message: 'Υποχρεωτικό πεδίο'
})

export default {
  components: {
    AgGridVue,
    vSelect,
    flatPickr,

    // Cell Renderer
    CellRendererLink,
    CellRendererStatus,
    CellRendererChecked,
    CellRendererVerified,
    CellRendererActions,
    GroupRowInnerRenderer,

    // Validation
    ValidationObserver,
    ValidationProvider,
  },
  data() {
    return {
      // Filter Options
      roleFilter: {label: 'All', value: 'all'},
      selectedFilter: {label: 'Όλες οι τιμές', value: 'all'},
      rowGroupPanelShow: null,
      favouriteFilter: false,
      lastChangedFilter: false,
      SkroutzSelectedStore: false,
      OnlyAvailableThroughFBS: false,
      Sponsored: false,
      MerchantFundedInstallments: false,
      CashOnDelivery: false,
      FreeShipping: false,
      OfficialReseller: false,
      Marketplace: false,
      castExpressDel: false,
      Instock: false,
      pro: false,
      supportsGrecaTrustmark: false,
      filterOption: [
        {label: 'Όλες οι τιμές', value: 'all'},
        {label: 'Όλες οι χαμηλότερες τιμές', value: 'allLower'},
        {label: 'Όλες οι χαμηλότερες τιμές (βάση εκπτωτικής τιμής)', value: 'allLowerDiscount'},
        {label: 'Χαμηλότατες τιμές', value: 'lowerOnly'},
        {label: 'Χαμηλότατες τιμές (βάση εκπτωτικής τιμής)', value: 'lowerOnlyDiscount'},
        {label: 'Όλες οι ίδιες τιμές', value: 'equal'},
        {label: 'Όλες οι ίδιες τιμές (βάση εκπτωτικής τιμής)', value: 'equalDiscount'},
      ],
      localeText: null,
      groupDisplayType: null,
      groupRowRendererParams: null,
      searchQuery: '',
      recordsData: [],
      date: null,
      hours: [],
      eshops: [],
      categories: [],
      products: [],
      selectedHour: null,
      selectedEshop: null,
      selectedCategory: null,
      selectedProduct: null,
      columnState: null,
      excelStyles: null,
      // AgGrid
      gridApi: null,
      columnApi: null,
      sideBar: null,
      gridColumnApi: null,
      gridOptions: {
        excelStyles: [
          {
            id: 'lessPrice',
            interior: {
              color: '#FF0000',
              pattern: 'solid',
            },
          },
          {
            id: 'greenPrice',
            interior: {
              color: '#008000',
              pattern: 'solid',
            },
          },
          {
            id: 'eqPrice',
            interior: {
              color: '#FFFFFF',
              pattern: 'solid',
            },
          }
        ],
        floatingFilter: true,
        filter: 'agTextColumnFilter',
        pagination: true,
        animateRows: true,
        resizable: true,
        suppressRowClickSelection: true,
        rowSelection: 'multiple',
      },
      defaultColDef: {
        sortable: true,
        resizable: true,
        suppressMenu: false,
        enableRowGroup: true,
      },
      columnDefs: [
        {
          headerName: 'UID',
          field: 'remoteId',
          filter: 'agTextColumnFilter',
          width: 120,
          cellClass: 'stringType',
        },
        {
          headerName: 'MPN',
          field: 'part_number',
          filter: 'agTextColumnFilter',
          width: 120,
          cellClass: 'stringType',
        },
        {
          headerName: 'A/A',
          field: 'aa',
          filter: 'agTextColumnFilter',
          width: 120,
        },
        {
          headerName: 'Όνομα Προϊόντος',
          field: 'name',
          filter: 'agTextColumnFilter',
          width: 200,
        },
        {
          headerName: 'Κατάστημα',
          field: 'formatedShopName', // eshop_partner
          filter: 'agTextColumnFilter',
          width: 150,
          valueGetter: function(params) {
            // First, check if params and params.data are defined
            if (params && params.data) {
              // Then proceed with your original logic
              if (params.data.formatedShopName || params.data.eshop_partner) {
                if (params.data.eshop_partner) {
                  return params.data.eshop_partner;
                }
                if (params.data.formatedShopName) {
                  return params.data.formatedShopName;
                }
              }
            }
          }
        },
        {
          headerName: 'Κατηγορία',
          field: 'catname',
          filter: 'agTextColumnFilter',
          width: 150,
        },
        {
          headerName: 'Υποκατηγορία',
          field: 'product_group',
          filter: 'agTextColumnFilter',
          width: 150,
        },
        {
          headerName: 'Κατασκευαστής',
          field: 'manufacturer',
          filter: 'agTextColumnFilter',
          width: 150,
        },
        {
          headerName: 'Ομάδα',
          field: 'dealers_group_name',
          filter: 'agTextColumnFilter',
          width: 150,
        },
        {
          headerName: 'Link',
          field: 'link',
          filter: 'agTextColumnFilter',
          width: 150,
        },
        {
          headerName: 'Τιμή Ασφαλείας',
          field: 'safe_price',
          filter: 'agNumberColumnFilter',
          cellStyle: {'text-align': 'right'},
          width: 150,
          valueFormatter: (params) => {
            if (
                params.data.safe_price === '' ||
                params.data.safe_price === undefined ||
                params.data.safe_price === null
            ) {
              return 0
            } else {
              return params.data.safe_price
            }
          },
        },
        {
          headerName: 'Τιμή Κόστους',
          field: 'cost_price',
          filter: 'agNumberColumnFilter',
          cellStyle: {'text-align': 'right'},
          width: 150,
          valueFormatter: (params) => {
            if (
                params.data.cost_price === '' ||
                params.data.cost_price === undefined ||
                params.data.cost_price === null
            ) {
              return 0
            } else {
              return params.data.cost_price
            }
          },
        },
        {
          headerName: 'Τιμή',
          field: 'erp_price',
          filter: 'agNumberColumnFilter',
          cellStyle: {'text-align': 'right'},
          width: 150,
          valueFormatter: (params) => {
            if (
                params.data.erp_price === '' ||
                params.data.erp_price === undefined ||
                params.data.erp_price === null
            ) {
              return 0
            } else {
              return new Intl.NumberFormat('de-DE', {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2
              }).format(params.data.erp_price);

              //return parseFloat(params.data.erp_price).toFixed(2)
            }
          },
        },
        {
          headerName: 'Τιμή με έκπτωση',
          field: 'promo_price',
          filter: 'agNumberColumnFilter',
          cellStyle: {'text-align': 'right'},
          width: 150,
          valueFormatter: (params) => {
            if (params.data.promo_price && (
                params.data.promo_price === '' ||
                params.data.promo_price === undefined ||
                params.data.promo_price === null)
            ) {
              return 0
            } else {
              return new Intl.NumberFormat('de-DE', {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2
              }).format(params.data.promo_price);
              //return parseFloat(params.data.promo_price).toFixed(2)
            }
          },
        },
        {
          headerName: 'Τιμή Πηγής',
          filter: 'agNumberColumnFilter',
          width: 150,
          field: 'price_selling',
          cellStyle: {'text-align': 'right'},
          valueFormatter: (params) => {
            if (params && params.data && params.data.price_selling) {
              return new Intl.NumberFormat('de-DE', {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2
              }).format(params.data.price_selling);

              //params.data.price_selling.toFixed(2)
            }
          },
          cellClass: function (params) {
            if (params && params.data && params.data.promo_price && parseFloat(params.data.promo_price) > 0) {
              if (params.data.price_selling < params.data.promo_price) {
                return 'lessPrice'
              } else if (params.data.promo_price && parseFloat(params.data.price_selling) === parseFloat(params.data.promo_price)) {
                return 'eqPrice'
              } else {
                return 'greenPrice'
              }
            } else {
              if (params && params.data && params.data.price_selling && params.data.price_selling < params.data.erp_price) {
                return 'lessPrice'
              } else if (params && params.data && params.data.price_selling && parseFloat(params.data.price_selling) === parseFloat(params.data.erp_price)) {
                return 'eqPrice'
              } else {
                return 'greenPrice'
              }
            }
          },
        },
        {
          headerName: 'Τιμή Πηγής με μεταφορικά',
          filter: 'agNumberColumnFilter',
          width: 150,
          hide: true,
          field: 'price_selling_incl_shipping',
          cellStyle: {'text-align': 'right'},
          valueFormatter: (params) => {
            if (params && params.data && params.data.price_selling_incl_shipping) {
              return new Intl.NumberFormat('de-DE', {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2
              }).format(params.data.price_selling_incl_shipping);

              //params.data.price_selling.toFixed(2)
            }
          },
          cellClass: function (params) {
            if (params && params.data && params.data.promo_price && parseFloat(params.data.promo_price) > 0) {
              if (params.data.price_selling_incl_shipping < params.data.promo_price) {
                return 'lessPrice'
              } else if (params.data.promo_price && parseFloat(params.data.price_selling_incl_shipping) === parseFloat(params.data.promo_price)) {
                return 'eqPrice'
              } else {
                return 'greenPrice'
              }
            } else {
              if (params && params.data && params.data.price_selling_incl_shipping && params.data.price_selling_incl_shipping < params.data.erp_price) {
                return 'lessPrice'
              } else if (params && params.data && params.data.price_selling_incl_shipping && parseFloat(params.data.price_selling_incl_shipping) === parseFloat(params.data.erp_price)) {
                return 'eqPrice'
              } else {
                return 'greenPrice'
              }
            }
          },
        },

        {
          headerName: '% Τιμή',
          field: 'percentStarting',
          filter: 'agNumberColumnFilter',
          cellStyle: {'text-align': 'right'},

          width: 150,
          valueFormatter: (params) => {
            return params.data.percentStarting + '%'
          },
        },
        {
          headerName: 'Αξία Τιμή',
          field: 'differenceStarting',
          filter: 'agNumberColumnFilter',
          cellStyle: {'text-align': 'right'},

          width: 150,
          valueFormatter: (params) => {
            //return params.data.differenceStarting + '€'
            let formattedNumber = new Intl.NumberFormat('de-DE', {
              minimumFractionDigits: 2,
              maximumFractionDigits: 2
            }).format(params.data.differenceStarting);
            return formattedNumber;
          },
        },
        {
          headerName: '% Τ.Έκπτωση',
          field: 'percentDiscount',
          filter: 'agNumberColumnFilter',
          cellStyle: {'text-align': 'right'},

          width: 150,
          valueFormatter: (params) => {
            return params.data.percentDiscount + '%'
          },
        },
        {
          headerName: 'Αξία Τ.Έκπτωση',
          field: 'differenceDiscount',
          filter: 'agNumberColumnFilter',
          cellStyle: {'text-align': 'right'},
          width: 150,
          valueFormatter: (params) => {
            let formattedNumber = new Intl.NumberFormat('de-DE', {
              minimumFractionDigits: 2,
              maximumFractionDigits: 2
            }).format(params.data.differenceDiscount);
            return formattedNumber;
            //return params.data.differenceDiscount + '€'
          },
        },
        {
          headerName: '% MAV',
          field: 'kbt',
          filter: 'agNumberColumnFilter',
          cellStyle: {'text-align': 'right'},
          width: 150,
          valueFormatter: (params) => {
            return params.data.mav + '%'
          },
        },
        {
          headerName: '% MAV1',
          field: 'kbe',
          filter: 'agNumberColumnFilter',
          cellStyle: {'text-align': 'right'},
          width: 150,
          valueFormatter: (params) => {
            return params.data.mav1 + '%'
          },
        },
        {
          headerName: '% MAV2',
          field: 'kbeta',
          filter: 'agNumberColumnFilter',
          cellStyle: {'text-align': 'right'},
          width: 150,
          valueFormatter: (params) => {
            return params.data.mav2 + '%'
          },
        },
        {
          headerName: 'Flagged',
          field: 'dealer_status',
          filter: 'agTextColumnFilter',
          width: 150,
          cellRendererFramework: 'CellRendererVerified',
          cellClass: 'text-center',
        },
        {
          headerName: 'Stock',
          field: 'instock',
          filter: 'agTextColumnFilter',
          width: 100,
          valueFormatter: (params) => {
            return params.data.instock == 'True' ? 'Ναι' : 'Όχι'
          },
        },
        {
          headerName: 'Διαθεσιμότητα',
          field: 'availability',
          filter: 'agTextColumnFilter',
          width: 150,
        },
        {
          headerName: 'Last Change',
          field: 'last_changed',
          filter: 'agTextColumnFilter',
          width: 150,
        },
        {
          headerName: 'Last Check',
          field: 'datetime',
          filter: 'agTextColumnFilter',
          width: 150,
        },
        {
          headerName: 'Επιλεγμένο Κατάστημα Skroutz',
          field: 'SkroutzSelectedStore',
          filter: 'agTextColumnFilter',
          width: 150,
        },
        {
          headerName: 'Διαθέσιμο Μόνο Μέσω FBS',
          field: 'OnlyAvailableThroughFBS',
          filter: 'agTextColumnFilter',
          width: 150,
        },
        {
          headerName: 'Χορηγούμενο',
          field: 'Sponsored',
          filter: 'agTextColumnFilter',
          width: 150,
        },
        {
          headerName: 'Δωρεάν Δόσεις',
          field: 'MerchantFundedInstallments',
          filter: 'agTextColumnFilter',
          width: 150,
        },
        {
          headerName: 'Αντικαταβολή',
          field: 'CashOnDelivery',
          filter: 'agTextColumnFilter',
          width: 150,
        },
        {
          headerName: 'Δωρεάν Αποστολή',
          field: 'FreeShipping',
          filter: 'agTextColumnFilter',
          width: 150,
        },
        {
          headerName: 'Επίσημος Μεταπωλητής',
          field: 'OfficialReseller',
          filter: 'agTextColumnFilter',
          width: 150,
        },
        {
          headerName: 'Marketplace',
          field: 'Marketplace',
          filter: 'agTextColumnFilter',
          width: 150,
        },
        {
          headerName: 'Pro Seller',
          field: 'pro',
          filter: 'agTextColumnFilter',
          width: 150,
        },
        {
          headerName: 'Greca Trustmark',
          field: 'supportsGrecaTrustmark',
          filter: 'agTextColumnFilter',
          width: 150,
        },
        {
          headerName: 'Express Delivery',
          field: 'castExpressDel',
          filter: 'agTextColumnFilter',
          width: 150,
        },
        {
          headerName: 'Sizes',
          field: 'category_size',
          filter: 'agTextColumnFilter',
          width: 150,
        },


        {
          headerName: 'Social Text',
          field: 'sku_social_stats',
          filter: 'agTextColumnFilter',
          width: 150,
        },
        {
          headerName: 'Reviews',
          field: 'reviews_count',
          filter: 'agTextColumnFilter',
          width: 150,
        },
        {
          headerName: 'Score',
          field: 'review_score',
          filter: 'agTextColumnFilter',
          width: 150,
        },
        {
          headerName: 'Σύνολο Καταστημάτων',
          field: 'shop_count',
          filter: 'agTextColumnFilter',
          width: 150,
        },
        {
          headerName: 'Skroutz Hub',
          field: 'skroutz_hub',
          filter: 'agTextColumnFilter',
          width: 150,
        },
        {
          headerName: 'Απόθεμα HUB',
          field: 'stock_hub',
          filter: 'agTextColumnFilter',
          width: 150,
        },
        {
          headerName: 'Source Link',
          field: 'skroutz_link',
          filter: 'agTextColumnFilter',
          width: 150,
        }
      ],

      // Cell Renderer Components
      components: {
        CellRendererLink,
        CellRendererStatus,
        CellRendererChecked,
        CellRendererVerified,
        CellRendererActions,
      },
    }
  },
  computed: {
    activeDates() {
      if (this.$store.getters.getReportActiveDates && this.$store.getters.getReportActiveDates.length > 0) {
        this.date = this.$store.getters.getReportActiveDates.reduce((a, b) => {
          return new Date(a) > new Date(b) ? a : b;
        });
      }
      return this.$store.getters.getReportActiveDates
    },
    paginationPageSize() {
      if (this.gridApi) return this.gridApi.paginationGetPageSize()
      else return 10
    },
    totalPages() {
      if (this.gridApi) return this.gridApi.paginationGetTotalPages()
      else return 0
    },
    currentPage: {
      get() {
        if (this.gridApi) return this.gridApi.paginationGetCurrentPage() + 1
        else return 1
      },
      set(val) {
        this.gridApi.paginationGoToPage(val - 1)
      },
    },
  },
  methods: {
    filterTable() {
      this.lastChangedFilter = this.date
      this.recordsData = this.recordsData.filter(item => {
        if (item.last_changed) {
          return item.last_changed.includes(this.date)
        } else {
          return false
        }
      })
    },
    findCrawlingSetsPerDate() {
      let vm = this
      if (!vm.date) {
        vm.date = vm.$store.getters.getReportActiveDates.reduce((a, b) => {
          return new Date(a) > new Date(b) ? a : b;
        });
      }
      vm.selectedHour = null
      axios
          .post('reports/findCrawlingSetsPerDate', {date: vm.date})
          .then((response) => {
            vm.hours = response.data.object
          })
    },
    getEshops() {
      let vm = this
      axios
          .get('eshops/list')
          .then((response) => {
            vm.eshops = response.data
            if (vm.eshops.length == 1) {
              vm.selectedEshop = vm.eshops[0]
            }
            let skroutz = {
              id: 0,
              name: 'Φθηνότερη τιμή skroutz',
            }
            // vm.eshops.push(skroutz)
          })
          .catch((error) => {
            console.log(error)
          })
          .then((response) => {
            // alert('3)');
          })
    },
    getCategories() {
      let vm = this
      axios
          .get('productCategories/list')
          .then((response) => {
            vm.categories = response.data
          })
          .catch((error) => {
            console.log(error)
          })
          .then((response) => {
            // alert('3)');
          })
    },
    getProductsByCategoryId() {
      let vm = this
      vm.selectedProduct = null
      axios
          .get(`products/listByCategoryId/${vm.selectedCategory.id}`)
          .then((response) => {
            vm.products = response.data
          })
          .catch((error) => {
            console.log(error)
          })
          .then((response) => {
            // alert('3)');
          })
    },
    generateReports(save = false) {
      let vm = this
      vm.$vs.loading()
      let payload = {
        group_crawl: vm.selectedHour ? vm.selectedHour.uid : null,
        eshopId: vm.selectedEshop,
        categoryId: vm.selectedCategory ? vm.selectedCategory.id : null,
        productId: vm.selectedProduct ? vm.selectedProduct.id : null,
        filter: vm.selectedFilter.value,
        favouriteFilter: vm.favouriteFilter,
        lastChangedFilter: vm.lastChangedFilter ? vm.date : null,
        extraFields: 1, // to distinguish the fields percent,diff, stock, availability to the request
        SkroutzSelectedStore: vm.SkroutzSelectedStore,
        OnlyAvailableThroughFBS: vm.OnlyAvailableThroughFBS,
        Sponsored: vm.Sponsored,
        MerchantFundedInstallments: vm.MerchantFundedInstallments,
        CashOnDelivery: vm.CashOnDelivery,
        FreeShipping: vm.FreeShipping,
        OfficialReseller: vm.OfficialReseller,
        Marketplace: vm.Marketplace,
        pro: vm.pro,
        supportsGrecaTrustmark: vm.supportsGrecaTrustmark,
        castExpressDel: vm.castExpressDel
      }

      axios
          .post('reports/reportsByList' + (save ? '/save' : ''), payload)
          .then((response) => {
            vm.$vs.loading.close()
            if (save) {
              window.location.replace(response.data.object)
            } else {
              vm.recordsData = response.data
            }
          }).then(() => {
            vm.loadGridState()
          })
          .catch((error) => {
            vm.$vs.loading.close()
          })
    },
    setColumnFilter(column, val) {
      const filter = this.gridApi.getFilterInstance(column)
      let modelObj = null

      if (val !== 'all') {
        modelObj = {type: 'equals', filter: val}
      }

      filter.setModel(modelObj)
      this.gridApi.onFilterChanged()
    },
    resetColFilters() {
      // Reset Grid Filter
      this.gridApi.setFilterModel(null)
      this.gridApi.onFilterChanged()
      this.$refs.filterCard.removeRefreshAnimation()
      this.selectedHour = null
      this.selectedEshop = null
      this.selectedCategory = null
      this.selectedProduct = null
      this.date = ''
    },
    updateSearchQuery(val) {
      this.gridApi.setQuickFilter(val)
    },
    onColumnMoved(params) {
      this.columnState = JSON.stringify(params.columnApi.getColumnState())
      localStorage.setItem('myColumnState', this.columnState)
    },
    loadGridState() {
      this.columnState = JSON.parse(localStorage.getItem('myColumnState'))
      this.gridColumnApi.applyColumnState({
          state: this.columnState,
          applyOrder: true,
        })
    },
    onGridReady(params) {
      let vm = this
      vm.params = params
      vm.gridApi = params.api
      vm.gridColumnApi = params.columnApi
      this.rowGroupPanelShow = 'always'
      setTimeout(() => {
        vm.loadGridState()
      }, 1000);
    },
  },
  mounted() {
    this.gridApi = this.gridOptions.api
    if (this.$vs.rtl) {
      const header = this.$refs.agGridTable.$el.querySelector(
          '.ag-header-container'
      )
      header.style.left = `-${String(
          Number(header.style.transform.slice(11, -3)) + 9
      )}px`
    }

    this.localeText = AG_GRID_LOCALE_EL
  },
  created() {
    let vm = this
    this.$store.dispatch('fetchReportActiveDates').then(() => {
      setTimeout(function() {
        vm.findCrawlingSetsPerDate()
      }, 1000)
    })
    this.getEshops()
    this.getCategories()
    this.groupDisplayType = 'groupRows'
    // this.groupRowRendererParams = {
    //   innerRenderer: 'GroupRowInnerRenderer',
    //   suppressCount: true,
    // }
  },
  beforeMount() {
    this.sideBar = {
      toolPanels: [
        {
          id: 'columns',
          labelDefault: 'Στήλες',
          labelKey: 'columns',
          iconKey: 'columns',
          toolPanel: 'agColumnsToolPanel',
          toolPanelParams: {
            suppressRowGroups: true,
            suppressValues: true,
            suppressPivots: true,
            suppressPivotMode: true,
            suppressSideButtons: true,
            suppressColumnFilter: true,
            suppressColumnSelectAll: true,
            suppressColumnExpandAll: true,
          },
        },
      ],
    }
    this.excelStyles = [
      {
        id: 'booleanType',
        dataType: 'boolean',
      },
      {
        id: 'stringType',
        dataType: 'string',
      },
      {
        id: 'dateType',
        dataType: 'dateTime',
      },
      {
        id: 'lessPrice',
        interior: {
          color: '#FF0000',
          pattern: 'Solid',
        },
        font: {
          color: '#ffffff',
        },
      },
      {
        id: 'greenPrice',
        interior: {
          color: '#228B22',
          pattern: 'Solid',
        },
        font: {
          color: '#ffffff',
        },
      },
    ];
  },
}
</script>

<style lang="scss">
#page-user-list {
  .user-list-filters {
    .vs__actions {
      position: absolute;
      right: 0;
      top: 50%;
      transform: translateY(-58%);
    }
  }
}

.lessPrice {
  background: red;
  color: white;
}

.goodPrice {
  background: forestgreen;
  color: white;
}

.ag-theme-material .ag-side-bar {
  border-left: 1px solid rgba(var(--vs-primary), 1);
  padding-left: 10px;
}

.vs-button-primary.vs-button-flat {
  font-size: 9px;
  padding: 5px !important;
  float: right;
}

.customLabel {
  width: 100%;
  display: inline-block;
}

.greenPrice {
  background: green;
  color: white;
}
</style>
